import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChart = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 16,
	viewBox: "0 0 20 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M18.3327 15.167H1.66602C1.32435 15.167 1.04102 14.9403 1.04102 14.667C1.04102 14.3937 1.32435 14.167 1.66602 14.167H18.3327C18.6743 14.167 18.9577 14.3937 18.9577 14.667C18.9577 14.9403 18.6743 15.167 18.3327 15.167Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.875 15.1663H8.125C7.78333 15.1663 7.5 14.9397 7.5 14.6663V2.66634C7.5 1.51967 8.29167 0.833008 9.625 0.833008H10.375C11.7083 0.833008 12.5 1.51967 12.5 2.66634V14.6663C12.5 14.9397 12.2167 15.1663 11.875 15.1663ZM8.75 14.1663H11.25V2.66634C11.25 1.89967 10.8 1.83301 10.375 1.83301H9.625C9.2 1.83301 8.75 1.89967 8.75 2.66634V14.1663V14.1663Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.83333 15.1663H2.5C2.15833 15.1663 1.875 14.9397 1.875 14.6663V6.66634C1.875 5.51967 2.60833 4.83301 3.83333 4.83301H4.5C5.725 4.83301 6.45833 5.51967 6.45833 6.66634V14.6663C6.45833 14.9397 6.175 15.1663 5.83333 15.1663ZM3.125 14.1663H5.20833V6.66634C5.20833 5.83301 4.75 5.83301 4.5 5.83301H3.83333C3.58333 5.83301 3.125 5.83301 3.125 6.66634V14.1663V14.1663Z",
			fill: "#3C3C3C"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.4993 15.167H14.166C13.8243 15.167 13.541 14.9403 13.541 14.667V10.0003C13.541 8.85366 14.2743 8.16699 15.4993 8.16699H16.166C17.391 8.16699 18.1243 8.85366 18.1243 10.0003V14.667C18.1243 14.9403 17.841 15.167 17.4993 15.167ZM14.791 14.167H16.8743V10.0003C16.8743 9.16699 16.416 9.16699 16.166 9.16699H15.4993C15.2493 9.16699 14.791 9.16699 14.791 10.0003V14.167V14.167Z",
			fill: "#3C3C3C"
		})
	]
});
export default SvgChart;
